export type RatesType = {
  dayRate?: number | null;
  nightRate?: number | null;
  _24HRate?: number | null;
  callRate?: number | null;
};

export const getRatesFields = ({ dayRate, nightRate, callRate, _24HRate }: RatesType) => {
  return [
    { label: 'Daytime', rate: dayRate },
    { label: 'Overnight', rate: nightRate },
    { label: '24hr', rate: _24HRate },
    { label: 'Call', rate: callRate },
  ];
};
